import { differenceInCalendarDays, differenceInMinutes } from 'date-fns';
import { useLocale } from '@adsk/alloy-react-helpers';
import { SHORT } from './consts';
import { displayDate } from './displayDate';
import { displayTime } from './displayTime';
import { getValidLocale } from './helpers';
/**
 * `useRelativeDate` takes a `Date` object, and returns a string illustrating the date.
 * Dates with a difference greater than 24 hours can be displayed in either a 'short' or 'numeric' format.
 * If necessary, user-specified start dates may be implemented instead of the current date.
 * @param date - `Date` object representing the relative date and time.
 * @param startDate - `Date` object representing the current date and time.
 * @param options - options object can contain following fields:
 *   * `format` - either "default", "short", or "numeric".
 *   * `locale` - developer designated locale (this will take precedence over browser setting, if language differs).
 * @returns a string illustrating `date` relative to the current date, or if applicable, `startDate`.
 */

var useRelativeDate = function useRelativeDate(date, startDate, options) {
  var _startDate;

  startDate = (_startDate = startDate) !== null && _startDate !== void 0 ? _startDate : new Date(Date.now());
  var diffMinutes = differenceInMinutes(startDate, date);
  var diffDays = differenceInCalendarDays(startDate, date);
  var format = options === null || options === void 0 ? void 0 : options.format;

  var _useLocale = useLocale(function (_ref) {
    var locale = _ref.locale;
    return require("./i18n/".concat(options !== null && options !== void 0 && options.locale ? getValidLocale(options.locale) : locale, ".json"));
  }),
      T = _useLocale.T;

  if (diffMinutes <= 1) {
    return T.translate('MOMENTS_AGO');
  } else if (diffMinutes > 1 && diffMinutes < 60) {
    return T.translate('MINUTES_AGO', {
      minutes: diffMinutes
    });
  } else if (diffMinutes >= 60 && diffDays === 0) {
    return T.translate('TODAY_AT', {
      time: displayTime(date, {
        format: 'short',
        utc: false
      })
    });
  } else if (diffDays === 1) {
    return T.translate('YESTERDAY_AT', {
      time: displayTime(date, {
        format: 'short',
        utc: false
      })
    });
  } else if (format === SHORT) {
    return T.translate('DATE_AT_TIME', {
      date: displayDate(date, {
        format: 'short',
        utc: false,
        year: true
      }),
      time: displayTime(date, {
        format: 'short',
        utc: false
      })
    });
  } else {
    return T.translate('DATE_TIME', {
      date: displayDate(date, {
        format: 'numeric',
        utc: false
      }),
      time: displayTime(date, {
        format: 'short',
        utc: false
      })
    });
  }
};

export default useRelativeDate;
//# sourceMappingURL=useRelativeDate.js.map